import scrollTo from '~/lib/scrollTo';
import { hideInvoicesInfo } from '~/lib/handleFooter';

export default {
  namespaced: true,
  state: {},
  actions: {
    scrollTo(_, val) {
      scrollTo(val);
    },
    scrollToElement(_, payload) {
      const el = payload?.element || payload;
      const offset = payload?.offset !== undefined ? payload.offset : 80;
      const rect = el.getBoundingClientRect();

      scrollTo({
        top: rect.top + window.scrollY - offset,
        left: rect.left + window.scrollX,
      });
    },
    hideFooterInvoicesInfo() {
      hideInvoicesInfo();
    },
  },
};
